import {PAdbContext} from "../PA.Core/PAdbContext";
import {AuditService} from "../PA.Core/Security/AuditService";
import {MetricViewBO} from "./MetricViewBO";
import {auditFieldFK, AuditUtils, IAuditField} from "../PA.Core/Basic/AuditUtils";


export class MetricViewBOAudit {


    static async MetricViewAuditBO(MetricViewBO: MetricViewBO): Promise<AuditService> {

        const self = MetricViewBO
        const auditService = new AuditService(self.dbContext)
        auditService.setReference("MetricView", self.drWB_MetricView.cif.WB_MTRVIEW_ID)

        // @ts-ignore
        self.deleteKeys = self.deleteKeys || {}
        // @ts-ignore
        let deleteKeys: any = self.deleteKeys

        const metricViewParams: IAuditField [] = [
            {fieldName: "METRIC_VIEW_NAME",              realName: "Name", bAllMsg: true }, //create
            {fieldName: "METRIC_VIEW_ID",                realName: "ID",  bAllMsg: true }, //create
            {fieldName: "METRIC_VIEW_USAGE",  realName: "Usage", domainId:"Metric_Usage" },
            {fieldName: "SORT_ORDER",  realName: "Sort Order"  },
            {fieldName: "MANUAL_IND",        realName: "Manual"},
            {fieldName: "OPTIONS",          realName: "Render Options"},


        ]

        //Metric View Metric Row
        const metricParams: IAuditField []=[
            {fieldName: "SORT_ORDER", realName:"Sort Order"},
            {fieldName: "MANUAL_IND",        realName: "Manual Ind"},
        ]


        // Execute Audit Logging
        await AuditUtils.logRecord(auditService, self.WB_MetricView, metricViewParams, {objectName: 'MetricView', deletedKeys: deleteKeys})

        //Metric View Metric Rows
        for(let aMetricViewMetricRow of self.drWB_MetricView.WB_MetricViewMetricRows){
            await AuditUtils.logRecord(auditService, aMetricViewMetricRow, metricParams,{objectName: 'Metrics', deletedKeys: deleteKeys})
        }

        return auditService
    }



}
